import { Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { InfinitySpin } from "react-loader-spinner";

import { GlobalContext } from "../../contexts/GlobalContext";
import { theme } from "../../utils/theme";

import { styles } from "./styles";

const Loader = ({ show = false }) => {
  const { state, dispatch } = useContext(GlobalContext);
  const { loading } = state;

  const { t } = useTranslation();

  return (
    loading.isOpen ||
    (show && (
      <Box sx={styles.loaderContainer}>
        <InfinitySpin color={theme.palette.primary.main} width="188" />
        <Typography sx={styles.text}>{t("One moment please...")}</Typography>
      </Box>
    ))
  );
};

export default Loader;
